// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_xAfNJ","breadcrumbs":"index_breadcrumbs_LL0-O"};